<template>
  <div>
    <v-row class="grey lighten-3" style="height: 1080px">
      <v-col md="4" class="hidden-sm-and-down side-image" style="background-color: #ffffff; font-size: 32px;">
        <a href="/" class="ml-4"><img src="../../assets/logo_text_black.svg" height="90" width="150"></a>
      </v-col>
      <v-col md="8" sm=12 style="background-color: #FFFFFF; position: relative;" class="">
        <v-row v-if="!isXsLayout()" style="" align="center" justify="end" class="ma-3">
          <p style="color: #9E9EA7;" class="mb-0 mr-3 font-weight-bold">すでにアカウントをお持ちの方</p>
          <v-btn to="/login" depressed rounded elevation="1" class="font-weight-bold">ログイン</v-btn>
        </v-row>
        <v-row class="signup-form overflow-hidden mx-1 mb-1" :style="{ marginTop: marginTop}">
          <v-card-title class="font-weight-black">
            <h4 class="font-weight-bold">ようこそVlaへ。</h4>
            <p style="color: #9E9EA7;" class="">アカウントを作成してVlaを活用しましょう。</p>
          </v-card-title>
          <v-card-text class="pt-0">
            <ValidationObserver ref="observer" v-slot="{ invalid }">
              <v-form ref="form" v-on:submit.prevent="registerUser">
                <v-row>
                  <v-col cols="12">
                    <span class="font-weight-bold">ユーザー名</span>
                    <ValidationProvider name="ユーザー名" rules="required|max:30" v-slot="{ errors }">
                      <v-text-field
                          label="ユーザー名を入力してください"
                          v-model="user.name"
                          :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols=12>
                    <span class="font-weight-bold">ユーザ-コード</span>
                    <ValidationProvider name="ユーザ-コード" rules="required|min:8|max:15|userCodeRegex" v-slot="{ errors }">
                      <v-text-field
                          label="ユーザーコードを入力してください"
                          v-model="user.user_code"
                          :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <span class="font-weight-bold">メールアドレス</span>
                    <ValidationProvider name="メールアドレス" rules="required|email|max:255" v-slot="{ errors }">
                      <v-text-field
                          label="メールアドレスを入力してください"
                          v-model="user.email"
                          :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols=12>
                    <span class="font-weight-bold">パスワード</span>
                    <ValidationProvider name="パスワード" rules="required|min:8|max:16|passwordRegex" v-slot="{ errors }">
                      <v-text-field
                          label="パスワードを入力してください"
                          type="password"
                          v-model="user.password"
                          :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols=12 class="text-center">
                    <v-btn
                        :loading="loading"
                        @click="loading = true"
                        color="primary"
                        class="button-shadow ma-4"
                        width="50%"
                        type="submit"
                        :disabled="invalid"
                    >確認画面へ</v-btn>
                  </v-col>
                  <v-col cols=12>
                    <hr class="hr-text" data-content="Or with">
                  </v-col>
                  <v-col cols=12 style="display: flex; justify-content: center;">
                    <router-link class="routerLink" style="text-decoration: none; color: inherit;" to="/login/google"><img src="../../assets/google_login.svg" width="126px" height="46px"></router-link>
                    <router-link class="routerLink" style="text-decoration: none; color: inherit;" to="/login/github"><img src="../../assets/github_login.svg" width="126px" height="46px"></router-link>
                    <router-link class="routerLink" style="text-decoration: none; color: inherit;" to="/login/little-heroes"><img src="../../assets/littleheroes_login.svg" width="126px" height="46px"></router-link>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </v-card-text>
          <v-col cols=12>
            <v-row style="" align="center" justify="end" class="">
              <a href="/" class="btn-primary" style="font-size: 14px; text-decoration: none;">ホームに戻る</a>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "SignupForm",
  data() {
    return {
      user: {},
      loading: false,
      height: window.innerHeight,
      marginTop: "220px",
      btnMessage: "会員登録"
    };
  },
  methods: {
    registerUser: function () {
      this.$store.dispatch(
        'signup/confirm',
        {
          'user': {
            name: this.user.name,
            user_code: this.user.user_code,
            email: this.user.email,
            password: this.user.password
          }
        }
      )
      .then(() => {
        this.$router.push('/signup/confirm')
      }).catch(error => {
        this.$swal('エラー', error, 'error');
        this.loading = false
      })
    },
    isXsLayout() {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return true;
      }
      this.marginTop = "0px";
      return false;
    },
  },
};
</script>
<style>
.side-image {
  background-image: url("../../assets/side_base.svg");
}
.hr-text {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: black;
  text-align: center;
  height: 1.5em;
  opacity: .5;
}
.hr-text:before {
  content: '';
  background: -webkit-linear-gradient(left, transparent, #818078, transparent);
  background: linear-gradient(to right, transparent, #818078, transparent);
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
}
.hr-text:after {
  content: attr(data-content);
  position: relative;
  display: inline-block;
  color: black;
  padding: 0 .5em;
  line-height: 1.5em;
  color: #818078;
  background-color: #fcfcfa;
}
.signup-form{
  max-width:550px; position:absolute; top:80%; left: 50%; transform: translate(-50%, -50%);
}
.disabled {
    opacity: 0.5;
    pointer-events: none;
}
@media(max-width: 959px) {
  .signup-form{
    position:relative;
    top: 20%;
  }
}
</style>